<template>
  <div>
    <business-list v-show="tabType === 1" @handleShow="handleShow" />
    <business-show v-if="tabType === 2" :rowId="id" @handleShow="handleShow"/>
    <inherit-customer v-if="tabType === 3" :rowId="id" :ywId="ywId" @handleShow="handleShow"/>
  </div>
</template>

<script>
import businessList from './list.vue'
import businessShow from './show.vue'
import inheritCustomer from './inherit.vue'
export default {
  components: { businessList,businessShow,inheritCustomer },
  data() {
    return {
      tabType: 1,
      id: null,
      ywId: null,
      technicalState:null
    }
  },
  methods: {
    handleShow(id, type,ywId) {
      this.tabType=type
      this.id = id
      this.ywId = ywId
      console.log('id: ',id);
    }
  }
}
</script>

<style>

</style>
